<template>
  <div>
    <van-popup round style="width: 80%" v-model="showTag" @closed="onClosed">
      <div class="flex column main">
        <div class="flex1 flex column overflow-hidden">
          <h3 class="title flex0 pt10 pb10 color_fff fs16 tac pl15 pr15">{{ title }}</h3>
          <div class="flex1 overflow-y-auto pl15 pr15 pt10 pb10" v-html="handlerMsg">
          </div>
        </div>
        <div class="footer flex0 pl30 pr30 pb15 pt15">
          <van-button type="info" class="mb10" block round @click="onClick('confirm')">
            知道了
          </van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import VTabs from "@/plugins/v-tabs";

export default {
  name: "confirm",
  components: {VTabs},
  data() {
    return {
      title: "",
      message: "",
      confirmBtnText: "我知道了",
      showTag: false
    }
  },
  computed: {
    handlerMsg() {
      let msg = this.message;
      return msg.replace(/[\r\n]/g, '<br/>')
    }
  },
  methods: {
    open() {
      this.showTag = true;
    },
    close() {
      this.showTag = false;
    },
    onClosed() {
      if (this.remove) this.remove(this.type);
    },
    onClick(type) {
      this.type = type;
      this.close()
    },
    onChange(data) {
      this.currTab = data.label;
      Log('data', data);
    }
  },
}
</script>

<style scoped lang="scss">
.title {
  background-size: cover;
  background-image: url("../../page/daysurgery/assets/矩形@3x.png");
}

.main {
  max-height: 70vh;
}
</style>



// WEBPACK FOOTER //
// src/plugins/dialog/ds-news-detail.vue